/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type AuthConfigContainer_settings = {
    readonly accountFeatures: {
        readonly changeUsername: boolean;
        readonly deleteAccount: boolean;
        readonly downloadComments: boolean;
    };
    readonly " $refType": "AuthConfigContainer_settings";
};
export type AuthConfigContainer_settings$data = AuthConfigContainer_settings;
export type AuthConfigContainer_settings$key = {
    readonly " $data"?: AuthConfigContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AuthConfigContainer_settings">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthConfigContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "CommenterAccountFeatures",
            "kind": "LinkedField",
            "name": "accountFeatures",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "changeUsername",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deleteAccount",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "downloadComments",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = '2bb419bf4aaf40c03e6d6c94197cbe8a';
export default node;
